/* eslint-disable no-useless-escape */
export const typeFieldsProtocol = [
  {
    label: 'Campo de importação',
    value: 'import_field'
  },
  {
    label: 'Primeira resposta da conversa',
    value: 'first_answer'
  },
  {
    label: 'Valor padrão',
    value: 'default_values'
  }
];

export const emailRegex =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;

export const optionsFieldsProtocolBase = [
  {
    label: 'Titulo',
    value: 'title'
  },
  {
    label: 'Telefone',
    value: 'telephone'
  },
  {
    label: 'Descrição',
    value: 'description'
  },
  {
    label: 'Motivo',
    value: 'reason_id'
  },
  {
    label: 'Submotivo',
    value: 'subreason_id'
  },
  {
    label: 'Status',
    value: 'current_status'
  },
  {
    label: 'Email',
    value: 'email'
  }
];
